var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#credit-card-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.92 2.5H4.252A4.17 4.17 0 0 0 .086 6.667h20A4.17 4.17 0 0 0 15.919 2.5M.086 13.334A4.17 4.17 0 0 0 4.253 17.5h11.666a4.17 4.17 0 0 0 4.167-4.166v-5h-20zm5.833-.417a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "credit-card-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.086 0h20v20h-20z"
})))));
export { SvgCreditCardIcon as ReactComponent };
export default __webpack_public_path__ + "bca3441f7da71a96ce6145808c3f7cce.svg";